module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutContainer', {
    attrs: {
      "columns": _vm.columnSplits
    }
  }, [_c('template', {
    slot: "header"
  }, [(_vm.isMaster) ? _c('div', {
    staticClass: "pa-2 red--text red lighten-4"
  }, [_vm._v("\n        Warning: you're in " + _vm._s(_vm.officeName) + " master. Changes affect all client files.\n        "), _c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "red"
    },
    attrs: {
      "href": "/templates",
      "target": "_blank"
    }
  }, [_vm._v("Open Doc Templates")])]) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    on: {
      "click": function($event) {
        return _vm.setSpecialTab('home')
      }
    }
  }, [_c('span', {
    staticClass: "heading-button",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.transaction.clients))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "active-indicator",
    class: {
      'active': _vm.isTransactionActive
    }
  }), _vm._v(" "), _c('ToolbarSearch', {
    on: {
      "search": _vm.searchWithinTransaction
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('v-progress-circular', {
    staticClass: "white--text",
    attrs: {
      "size": 20,
      "width": 2,
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200,
      "max-height": "400"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }], null, false, 1568013183)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', [_c('a', {
    staticClass: "transparent",
    attrs: {
      "href": ("/" + _vm.tenantKey + "/transaction/" + (_vm.transaction.masterKey)),
      "target": "_blank"
    }
  }, [_c('v-list-item-title', [_vm._v("Open the Master Template")])], 1)]), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push(("/" + _vm.tenantKey + "/document-checklist/" + _vm.transactionKey))
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Checklist")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.deleteAll
    }
  }, [_c('v-list-item-title', [_vm._v("Delete All Fields")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.deleteTransaction
    }
  }, [_c('v-list-item-title', [_vm._v("Delete Transaction")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.importTab(_vm.selectedTab)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Refresh Current Tab")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.showTransactionHistory()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Activity History")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.testFunction
    }
  }, [_c('v-list-item-title', [_vm._v("Test Function")])], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Advanced")]), _vm._v(" "), (!_vm.isMaster) ? _c('v-list-item', {
    on: {
      "click": _vm.makeTemplate
    }
  }, [_c('v-list-item-title', [_vm._v("Make this a Template")])], 1) : _vm._e(), _vm._v(" "), (_vm.isMaster) ? _c('v-list-item', {
    on: {
      "click": _vm.removeTemplate
    }
  }, [_c('v-list-item-title', [_vm._v("Remove as template")])], 1) : _vm._e(), _vm._v(" "), (_vm.columnSplits != '50/50') ? _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.columnSplits = '50/50'
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Bigger Comments Column")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.debugMode = !_vm.debugMode
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Debug Mode")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "value": _vm.debugMode
    }
  })], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
    on: {
      "click": _vm.viewMilestone
    }
  }, [_c('v-list-item-title', [_vm._v("View Milstone in Console")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-bar"
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('div', [_c('div', {
    staticClass: "tab no-select",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      key: tab.key,
      on: {
        "click": function($event) {
          return _vm.selectTab(tab)
        }
      }
    }, [_c('div', {
      key: tab.key,
      staticClass: "tab clickable",
      class: {
        selected: tab == _vm.selectedTab
      }
    }, [_c('div', {
      staticClass: "clickable",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('v-icon', {
      staticClass: "tab-icon",
      class: {
        'complete': tab.complete
      },
      staticStyle: {
        "margin-top": "-5px",
        "margin-right": "5px"
      }
    }, [_vm._v("star")]), _vm._v(" "), _c('div', {
      staticClass: "no-select no-wrap"
    }, [_vm._v(_vm._s(tab.title))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-right": "-15px",
        "margin-top": "-2px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "menu-icon"
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editTab(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit Tab")])], 1), _vm._v(" "), (_vm.clipboard.items.length == 0) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.moveTabToClipboard(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Cut")])], 1) : _vm._e(), _vm._v(" "), (_vm.clipboard.action == 'Tab') ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.pasteTabFromClipboard(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Paste")])], 1) : _vm._e(), _vm._v(" "), (!tab.complete) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.completeElement(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Complete")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.importTab(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Refresh Tab")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.reseedOrder
      }
    }, [_c('v-list-item-title', [_vm._v("Reseed Sort Order")])], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.tabMaintenance(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Element Maintenance")])], 1) : _vm._e()], 1)], 1)], 1)], 1)])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('div', {
    staticClass: "tab no-select",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', [(!_vm.isLoading) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "tab no-select"
        }, on), [_c('v-icon', {
          staticStyle: {
            "margin-top": "-3px"
          },
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_vm._v("settings")])], 1)]
      }
    }], null, false, 763598367)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.addTab
    }
  }, [_c('v-list-item-title', [_vm._v("Add Tab")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.refreshTabs
    }
  }, [_c('v-list-item-title', [_vm._v("Refresh Tabs")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.setSpecialTab('settings')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Transaction Settings")])], 1)], 1)], 1) : _vm._e()], 1)], 2)])], 1), _vm._v(" "), _c('div', {
    ref: "col1",
    attrs: {
      "slot": "col1"
    },
    slot: "col1"
  }, [_c('div', {
    staticClass: "flex-grid"
  }, _vm._l((_vm.tabElements), function(element) {
    return _c('div', {
      key: element.key,
      ref: element.name,
      refInFor: true,
      staticClass: "element clickable",
      class: {
        selected: _vm.isElementSelected(element), important: element.important, compact: element.compact
      },
      style: (_vm.getElementStyle(element)),
      on: {
        "dblclick": function($event) {
          return _vm.elementDoubleClicked(element)
        },
        "click": function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.elementClicked(element)
        },
        "!click": [function($event) {
          if (!$event.metaKey) { return null; }
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMulti(element)
        }, function($event) {
          if (!$event.ctrlKey) { return null; }
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMulti(element)
        }]
      }
    }, [_c('table', {
      staticStyle: {
        "table-layout": "fixed",
        "width": "100%",
        "max-width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "99%",
        "padding": "0px",
        "border-radius": "6px"
      },
      style: ({
        'opacity': (element.na ? 0.3 : 'inherit'),
        'background-color': _vm.getElementBackground(element)
      })
    }, [_c('elementItem', {
      attrs: {
        "element": element
      },
      on: {
        "select": _vm.selectSingle,
        "change": _vm.storeElementValue,
        "button": _vm.buttonElementClicked,
        "action": _vm.actionElement,
        "save-lookup": _vm.saveLookup
      }
    })], 1), _vm._v(" "), (element.value && element.value.length > 10 && element.value.startsWith('http') && element.type != 'File') ? _c('td', {
      attrs: {
        "width": "50px"
      }
    }, [_c('a', {
      staticClass: "transparent",
      attrs: {
        "href": element.value,
        "target": "_blank"
      }
    }, [_c('v-btn', {
      staticClass: "elevation-0",
      attrs: {
        "small": "",
        "fab": "",
        "color": "blue lighten-4"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("public")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15px",
        "padding": "0px"
      },
      style: (_vm.menuContainerStyle(element)),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    }, [_c('v-menu', {
      staticStyle: {
        "margin-left": "-5px",
        "margin-right": "-8px"
      },
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "menu-icon"
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [(!_vm.isElementSelected(element)) ? [(element.type == 'Text') ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.addToComments(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add to Comments")])], 1) : _vm._e(), _vm._v(" "), (element.type == 'Text') ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.sendElementToNewWindow(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Send to New Window")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editElement(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.makeTaskFromElement(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Make Task")])], 1), _vm._v(" "), (!element.important) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.makeImportant(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Important")])], 1) : _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.removeImportant(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Not Important")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.showElementHistory(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("History")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.toggleNotApplicable(element)
        }
      }
    }, [_c('v-list-item-title', [(!element.na) ? [_vm._v("Not ")] : _vm._e(), _vm._v("Applicable\n                                        ")], 2)], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.addAfterElement(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("New Element")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.selectMulti(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Select")])], 1), _vm._v(" "), (_vm.clipboard.items.length) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.pasteFromClipboard(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Paste")])], 1) : _vm._e()] : [_c('v-list-item', {
      on: {
        "click": _vm.cloneSelectedElements
      }
    }, [_c('v-list-item-title', [_vm._v("Clone")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.moveToClipboard('Cut')
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Cut")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.moveToClipboard('Copy')
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Copy")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteElements(_vm.selectedElements)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.addFilter(_vm.selectedElements)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add Filter")])], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.elementMaintenance(_vm.selectedElements)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Element Maintenance")])], 1) : _vm._e()]], 2)], 1)], 1)])]), _vm._v(" "), (element.scheduleVisible) ? _c('ElementScheduler', {
      attrs: {
        "element": element
      },
      on: {
        "schedule": _vm.scheduleClicked
      }
    }) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#eee",
      "border-radius": "8px",
      "padding": "10px"
    },
    attrs: {
      "slot": "col2"
    },
    slot: "col2"
  }, [_c('TimeTracker', {
    staticClass: "mt-0 mb-1 mr-1",
    attrs: {
      "related-id": _vm.transactionKey,
      "title": _vm.transaction.clients,
      "payload": _vm.timeTrackerPayload
    }
  }), _vm._v(" "), _c('SimultaneousTransactions', {
    attrs: {
      "transactionKey": _vm.transactionKey
    }
  }), _vm._v(" "), (_vm.clipboard.items.length) ? _c('div', {
    staticClass: "clipboard"
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-right": "10px"
    }
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "grey"
    }
  }, [_vm._v("assignment")])], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "padding": "4px 8px 4px 8px",
      "float": "right",
      "border": "solid 1px #888"
    },
    on: {
      "click": _vm.clearClipboard
    }
  }, [_vm._v("Clear")]), _vm._v("\n        Clipboard (" + _vm._s(this.clipboard.action) + ")"), _c('br'), _vm._v("\n        " + _vm._s(this.clipboard.items.map(function (o) { return o.title; }).join(', ')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "background-color": "#ddd"
    },
    on: {
      "click": function($event) {
        _vm.importantVisible = !_vm.importantVisible
      }
    }
  }, [(_vm.importantVisible) ? _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_up")]) : _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_down")]), _vm._v("\n        Important Stuff\n\n    ")], 1), _vm._v(" "), _c('v-expand-transition', [(_vm.importantVisible) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.importantElements), function(element) {
    return _c('v-menu', {
      key: element.key,
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('div', _vm._g({
            key: element.key,
            staticClass: "clickable hoverable",
            staticStyle: {
              "display": "flex",
              "color": "#555",
              "padding": "7px",
              "border-top": "dotted 1px #ccc",
              "width": "100%"
            }
          }, on), [(element.type != 'Widget') ? _c('div', {
            staticStyle: {
              "font-weight": "500",
              "width": "120px",
              "margin-right": "10px"
            }
          }, [_vm._v("\n                        " + _vm._s(element.title) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
            staticStyle: {
              "flex-grow": "1",
              "font-weight": "400",
              "margin-right": "3px",
              "overflow": "auto"
            }
          }, [(element.type != 'Rating') ? _c('div', {
            staticClass: "text-selectable",
            staticStyle: {
              "overflow-x": "auto"
            },
            domProps: {
              "innerHTML": _vm._s(_vm.formatElement(element))
            }
          }) : _vm._e(), _vm._v(" "), (element.widget == 'Outstandings Diagram') ? _c('OutstandingsDiagram') : _vm._e(), _vm._v(" "), _c('div', {
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.ratingClicked(element)
              }
            }
          }, [(element.type == 'Rating') ? _c('v-rating', {
            staticStyle: {
              "margin-top": "-10px",
              "margin-left": "-10px",
              "margin-bottom": "-10px"
            },
            attrs: {
              "color": "yellow darken-2",
              "background-color": "grey lighten-2"
            },
            model: {
              value: (element.value),
              callback: function($$v) {
                _vm.$set(element, "value", $$v)
              },
              expression: "element.value"
            }
          }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
            staticStyle: {
              "flex-basis": "0"
            }
          }, [_c('v-icon', {
            staticStyle: {
              "font-size": "12px"
            },
            attrs: {
              "color": "grey lighten-1"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.removeImportant(element)
              }
            }
          }, [_vm._v("clear")])], 1)])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.jumpToElement(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Jump to Tab")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Copy to Clipboard")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 2) : _vm._e()]), _vm._v(" "), (!_vm.contactsVisible) ? _c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "background-color": "#ddd"
    },
    on: {
      "click": function($event) {
        _vm.contactsVisible = true
      }
    }
  }, [(_vm.contactsVisible) ? _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_up")]) : _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_down")]), _vm._v("\n        Show Contacts\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-expand-transition', [(_vm.contactsVisible) ? _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('v-menu', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "max-height": "300",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "width": "100%"
          }
        }, on), [_vm._v("\n                    Add Contact\n                ")])]
      }
    }], null, false, 1263856287)
  }, [_vm._v(" "), _c('v-list', [_vm._l((_vm.roles), function(role) {
    return _c('v-list-item', {
      key: role,
      on: {
        "click": function($event) {
          return _vm.addContact(role)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(role))])], 1)
  }), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.addContact('Other')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Other")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "flex-basis": "35px",
      "flex-grow": "0",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.contactsVisible = false
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-top": "-2px",
      "margin-left": "-3px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_up")])], 1)]), _vm._v(" "), _c('TransactionContacts', {
    attrs: {
      "contactElements": _vm.contactElementsUnique
    },
    on: {
      "click": _vm.viewContact
    }
  }), _vm._v(" "), (_vm.clients.length == 2) ? _c('div', {
    staticClass: "pb-3 pl-2 "
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.emailBothClients($event)
      }
    }
  }, [_vm._v("\n                Email Both Clients\n            ")]), _vm._v(" \n            "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.clipboardBothClients($event)
      }
    }
  }, [_vm._v("\n                Both to Clipboard\n            ")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "background-color": "#ddd"
    },
    on: {
      "click": _vm.showFileDialog
    }
  }, [(_vm.uploadingCount) ? [_c('v-progress-circular', {
    staticClass: "grey--text",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": 20,
      "width": 2,
      "indeterminate": ""
    }
  }), _vm._v("\n            Uploading " + _vm._s(_vm.uploadingCount) + " Files\n        ")] : [_vm._v("\n            " + _vm._s(this.fileElements && this.fileElements.length ? this.fileElements.length : 'No') + " Files\n        ")], _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("mdi-dots-horizontal")])], 2), _vm._v(" "), _c('TransactionTasks'), _vm._v(" "), _c('TransactionComments'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "background-color": "#ddd"
    },
    on: {
      "click": _vm.mailLogClick
    }
  }, [(_vm.emailsVisible) ? _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_up")]) : _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_down")]), _vm._v("\n        Emails\n    ")], 1), _vm._v(" "), _c('v-expand-transition', [(_vm.emailsVisible) ? _c('div', {
    staticClass: "light-text"
  }, [_c('TransactionMail', {
    attrs: {
      "items": _vm.mailLog,
      "showTo": true
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('template', {
    slot: "dialogs"
  }, [_c('ElementDialog', {
    attrs: {
      "settings": _vm.elementDialog.settings,
      "model": _vm.elementDialog.model
    },
    on: {
      "save": _vm.saveElement,
      "delete": _vm.deleteElement
    }
  }), _vm._v(" "), _c('LookupDialog', {
    attrs: {
      "settings": _vm.lookupDialog.settings,
      "element": _vm.lookupDialog.element
    },
    on: {
      "save": _vm.saveLookupFromDialog
    }
  }), _vm._v(" "), _c('FilterEditor', {
    attrs: {
      "settings": _vm.filterEditorDialog.settings,
      "elements": _vm.filterEditorDialog.elements,
      "model": _vm.filterEditorDialog.model
    },
    on: {
      "save": _vm.saveFilter,
      "delete": _vm.deleteFilter
    }
  }), _vm._v(" "), _c('ContactSelector', {
    attrs: {
      "visible": _vm.contactSelector.visible,
      "title": _vm.contactSelector.title,
      "data": _vm.contactSelector.data
    },
    on: {
      "select": _vm.linkContactFromElement,
      "cancel": function($event) {
        _vm.contactSelector.visible = false
      }
    }
  }), _vm._v(" "), _c('TransactionContact', {
    attrs: {
      "settings": _vm.transactionContactDialog.settings,
      "title": "",
      "transactionKey": _vm.transactionKey,
      "element": _vm.transactionContactDialog.element
    },
    on: {
      "close": function($event) {
        _vm.transactionContactDialog.settings.visible = false
      },
      "unlink": _vm.unlinkContact,
      "edit-element": _vm.editElement,
      "refresh": _vm.refreshContact
    }
  }), _vm._v(" "), _c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email,
      "returnObject": _vm.emailDialog.returnObject
    },
    on: {
      "sent": _vm.sentEmailMessage
    }
  }), _vm._v(" "), _c('SmsDialog', {
    attrs: {
      "settings": _vm.smsDialog.settings,
      "recipients": _vm.smsDialog.recipients,
      "message": _vm.smsDialog.message,
      "returnObject": _vm.smsDialog.returnObject
    },
    on: {
      "sent": _vm.sentSMSMessage
    }
  }), _vm._v(" "), _c('FileDialog', {
    attrs: {
      "files": _vm.fileElements,
      "settings": _vm.fileDialog.settings
    }
  }), _vm._v(" "), _c('TaskDialog', {
    attrs: {
      "task": _vm.taskDialog.model,
      "settings": _vm.taskDialog.settings
    },
    on: {
      "save": _vm.saveTask
    }
  }), _vm._v(" "), _c('GenericListDialog', {
    attrs: {
      "items": _vm.genericListDialog.items,
      "settings": _vm.genericListDialog.settings,
      "clickHandler": _vm.genericListDialog.clickHandler
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aaa62db6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Transaction.vue
// module id = 2640
// module chunks = 1